angular.module('rings-app.form.helpers', ['usersService'])
/**
 * Directive to manage valid/invalid states of remote-validated Data.
 * It stores an internal array of values declared invalid by the server.
 * Generates the form error specified in case the user re-types the same invalid values,
 * clears the errors in case the user changes the ngModel.
 *
 * usage:
 * <input type="email" ng-model="email" remote-validated="used">
 *
 * NOTE: Your controllers have to make the field invalid in case *your* server says so.
 */
.directive('remoteValidated', function () {
  return {
    restrict: 'A',
    scope: false,
    require: 'ngModel',
    link: function (scope, elem, attrs, controller) {
      var invalidItems = [];
      scope.$watch(attrs.ngModel, function (newValue, oldValue) {
        if (newValue) {
          // Check the array of already-bad items
          if (invalidItems.indexOf(newValue) !== -1) {
            return controller.$setValidity(attrs.remoteValidated, false);
          }
          // When the model changes, it checks if the previous value was
          // triggering the error from server-side
          if (controller.$error[attrs.remoteValidated]) {
            invalidItems.push(oldValue);
          }
          controller.$setValidity(attrs.remoteValidated, true);
        }
      });
    }
  };
})
/*
* directive to validate zipcode
* checks, if the zipcode consists of exactly 5 number, first number can not be 0
*/
.directive('zipcode', function($timeout) {
    return {
      require: 'ngModel',
      controller: function($element) {
        var ctrl = $element.controller('ngModel');
        ctrl.$validators.invalidPostcode = 
          function(modelValue, viewValue) {
            // test for zipcode - not set, or length is 0, or exactly five numbers, first can notw be 0
            return !viewValue || viewValue.length == 0 || /^[0-9]{5}$/i.test(viewValue);
        };
      }
    };
})
/*
* directive to validate zipcode
* checks, if the zipcode consists of exactly 5 number, first number can not be 0
*/
.directive('season', function($timeout) {
    return {
      require: 'ngModel',
      controller: function($element) {
        var ctrl = $element.controller('ngModel');
        ctrl.$validators.invalidSeason = 
          function(modelValue, viewValue) {
            // test for zipcode - not set, or length is 0, or exactly five numbers, first can notw be 0
            return !viewValue || viewValue.length == 0 || /^\d{1,2}\.\d{1,2}$/i.test(viewValue);
        };
      }
    };
})
/*
* directive to validate confirm password
* checks, if the password in element(input) is the same as the password in ng-model provided
* usage: 
<input class="form-control" required type="password" name="new" ng-model="pwd1" />
<input class="form-control" required type="password" name="confirm" ng-model="pwd2" pw-check="pwd1" />
*/
.directive('pwCheck', [function () {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        var firstPassword = '#' + attrs.pwCheck;
        elem.add(firstPassword).on('keyup', function () {
          scope.$apply(function () {
            var pwd1 = scope.$eval(attrs.pwCheck);
            var pwd2 = elem.val();
            var v = pwd1===pwd2;
            ctrl.$setValidity('pwmatch', v);
          });
        });
      }
    }
 }])
/*when input/textarea are focused or clicked, select text inside*/
.directive('selectOnFocus', ['$window', function ($window) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('focus', function () {
                if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                    this.setSelectionRange(0, this.value.length)
                }
            });
            element.on('click', function () {
              if (!$window.getSelection().toString()) {
                    // Required for mobile Safari
                this.setSelectionRange(0, this.value.length)
              }
            });
        }
    };
}])
/*
* directive to validate if one field is bigger than other
*/
.directive('lowerThan', [
  function() {

    var link = function($scope, $element, $attrs, ctrl) {

      var validate = function(viewValue) {
        var comparisonModel = $attrs.lowerThan;
        if(!viewValue || !comparisonModel){
          // It's valid because we have nothing to compare against
          ctrl.$setValidity('lowerThan', true);
        } 
        if (comparisonModel) {
          var t = new Date($scope.$eval($attrs.lowerThan));
          t.setDate(t.getDate() + 1);      
        }
        if (viewValue) {

          var regexp = /^([0-9]{1,2})\.([0-9]{1,2})\.([0-9]{4})$/i;
          if (regexp.test(viewValue)){
            var match = regexp.exec(viewValue);
            var d = match[1];
            var m = match[2];
            var y = match[3];
            var dt = y+'-'+m+'-'+d;
            var f = new Date(dt);
          } else {
            var f = new Date(viewValue);
          }          
        }

        // if one of the values is not set, treat as valid
        if (t == null || typeof(t) == 'undefined' || f == null || typeof(f) == 'undefined'){
          ctrl.$setValidity('lowerThan', true);
        } else {
          ctrl.$setValidity('lowerThan', t >= f);
        }
          
        // It's valid if model is lower than the model we're comparing against
        return viewValue;
      };

      ctrl.$parsers.unshift(validate);
      ctrl.$formatters.push(validate);

      $attrs.$observe('lowerThan', function(comparisonModel){
        return validate(ctrl.$viewValue);
      });      
      
    };

    return {
      require: 'ngModel',
      link: link
    };

  }
])
/*
* directive to validate if value is multiplier of another (modus = 0)
*/
.directive('multiplier', [
  function() {

    var link = function($scope, $element, $attrs, ctrl) {

      var validate = function(viewValue) {
        var comparisonModel = $attrs.multiplier;
        if(!viewValue || !comparisonModel){
          // It's valid because we have nothing to compare against
          ctrl.$setValidity('multiplier', true);
        } 
        if (comparisonModel) {
          var step = $scope.$eval($attrs.multiplier);
        }
        if (viewValue) {
          var value = viewValue;
        }
        // if one of the values is not set, treat as valid
        if (step == null || typeof(step) == 'undefined' || value == null || typeof(value) == 'undefined'){
          ctrl.$setValidity('multiplier', true);
        } else {
          ctrl.$setValidity('multiplier', value % step == 0);
        }
          
        // It's valid if model is lower than the model we're comparing against
        return viewValue;
      };

      ctrl.$parsers.unshift(validate);
      ctrl.$formatters.push(validate);

      $attrs.$observe('multiple', function(comparisonModel){
        return validate(ctrl.$viewValue);
      });      
      
    };

    return {
      require: 'ngModel',
      link: link
    };

  }
])
.directive('datepickerLocaldate', ['$parse', function ($parse) {
    var directive = {
        restrict: 'A',
        require: ['ngModel'],
        link: link
    };
    return directive;

    function link(scope, element, attr, ctrls) {
        var ngModelController = ctrls[0];

        // called with a JavaScript Date object when picked from the datepicker
        ngModelController.$parsers.push(function (viewValue) {
            if (!viewValue) {
              return undefined;
            }
            if (angular.isDate(viewValue)) {
              // undo the timezone adjustment we did during the formatting
              viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
              // we want date in Unix timestamp
              return new Date(viewValue);
              //return new Date(Math.round(new Date(viewValue).getTime() / 1000.0));
            } else {
              return viewValue;
            }
            
        });

        // called with a Unix timestamp to format
        ngModelController.$formatters.push(function (modelValue) {
            if (!modelValue) {
                return undefined;
            }
            if (angular.isDate(modelValue)) {
              // date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
              var dt = new Date(modelValue);
              //var cp = angular.copy(dt);
              // 'undo' the timezone offset again (so we end up on the original date again)
              dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
              return dt;
            } else {
              return modelValue;
            }
            
        });
    }
}]);